import * as React from 'react';

import { DocumentMessage } from '../../../../components/DocumentMessage';
import { DocumentMessageLayout } from '../../../../components/DocumentMessageLayout';
import { ImageAsDocumentMessageLayout } from '../../../../components/ImageAsDocumentMessageLayout';
import { MessageReplyQuoteContainer } from '../../../MessageReplyQuoteContainer';
import { ChatMessageMetaContainer } from '../ChatMessageMetaContainer';
import { ErrorSignContainer } from '../ErrorSignContainer';
import { ErrorTextContainer } from '../ErrorTextContainer';
import { useMessageContext } from '../../../../utils/messageContext';
import { useApplicationContext } from '../../../../utils/applicationContext';
import { useDispatch } from 'react-redux';
import { retrySendMessageById } from '../../../../actions/sendMessage/retrySendMessageById';
import { deleteMessageFromChat } from '../../../../actions/sendMessage';
import { useDocument } from './hooks/useDocument';
import { useImageAsDocument } from './hooks/useImageAsDocument';
import { FileMessageInfo } from '../../../../components/FileMessageInfo';

export const DocumentMessageContainer: React.FC = () => {
  const {
    chatId,
    messageId,
    message: { status: messageStatus, isOutcoming },
    messageType,
    isLastInChain,
    userColor,
    highlighted,
    messageRef,
    onHighlightEnd,
  } = useMessageContext();

  const { custom } = useApplicationContext();

  const document = useDocument();

  const imageAsDocument = useImageAsDocument();

  const dispatch = useDispatch();

  const handleCancel = React.useCallback(() => {
    if (chatId && document) {
      document.cancelLoad();
      dispatch(deleteMessageFromChat({ chatId, messageId, messagesMap: custom.messagesMap }));
    }
  }, [chatId, custom.messagesMap, document, dispatch, messageId]);

  const handleReload = React.useCallback(() => {
    dispatch(retrySendMessageById(chatId, messageId));
  }, [chatId, messageId, dispatch]);

  if (document) {
    return (
      <DocumentMessageLayout
        errorSign={<ErrorSignContainer />}
        errorText={<ErrorTextContainer />}
        messageType={messageType}
        isLastMessageInChain={isLastInChain}
        messageMeta={<ChatMessageMetaContainer />}
        userColor={userColor}
        replyQuote={<MessageReplyQuoteContainer />}
        highlighted={highlighted}
        onHighlightEnd={onHighlightEnd}
        documentMessage={
          <DocumentMessage
            {...document}
            isOutcoming={isOutcoming}
            messageStatus={messageStatus}
            onCancel={handleCancel}
            onReload={handleReload}
          />
        }
        ref={messageRef}
      />
    );
  }

  if (imageAsDocument) {
    const { imageNode, ...imageDocumentInfo } = imageAsDocument;

    return (
      <ImageAsDocumentMessageLayout
        errorSign={<ErrorSignContainer />}
        errorText={<ErrorTextContainer />}
        messageType={messageType}
        isLastMessageInChain={isLastInChain}
        image={imageNode}
        imageInfo={<FileMessageInfo {...imageDocumentInfo} isOutcoming={isOutcoming} />}
        userColor={userColor}
        replyQuote={<MessageReplyQuoteContainer />}
        highlighted={highlighted}
        onHighlightEnd={onHighlightEnd}
        ref={messageRef}
        messageMeta={<ChatMessageMetaContainer />}
      />
    );
  }

  return null;
};
